<template>
    <div>
       <h4 class="title">申請移轉</h4>
       <div class="member_content">
            <table class="table table-bordered  table-nonfluid table-responsive">
                <tbody>
                    <tr>
                        <td>姓名&nbsp;:&nbsp;</td>
                        <td>
                        {{personal.org_name}}({{personal.org_mid}})
                        </td>
                    </tr>
                    <tr>
                        <td>信箱&nbsp;:&nbsp;</td>
                        <td>{{personal.email}}</td>
                    </tr>
                    
                    <tr>
                        <td>推薦人移轉類型&nbsp;:&nbsp;</td>
                        <td>
                            <select class="form-control" v-model="transferType" required>
                                <option v-for="option in transferCategory" v-bind:value="option.value">
                                    {{option.text}}
                                </option>
                            </select>
                        </td>
                    </tr>
                    <tr>
                        <td>預計移轉對象&nbsp;:&nbsp;</td>
                        <td>
                            <input type="numbeer" v-model="targetOrgMid"/> (請填寫會員編號)
                        </td>
                    </tr>
                    <tr>
                        <td>具體申請是由&nbsp;:&nbsp;</td>
                        <td>
                            <textarea class="form-control" v-model="reason" placeholder="任一申請類型，請都填寫具體事由再進行送出" rows="5"></textarea>
                        </td>
                    </tr>
                </tbody>
                <tfoot>
                    <tr>
                        <td colspan="2">
                            <button type="button" class="btn btn-info btn-sm" @click="applyTransfer()">確認申請</button>
                            <button type="button" class="btn btn-default btn-sm" @click="cancel()">取消</button>
                        </td>
                    </tr>
                </tfoot>
            </table>
      </div>
    </div>
</template>

<script>
import {mapActions, mapGetters} from 'vuex'

export default {
  name: 'Transfer',
  data () {
    return {
      memberurl: this.$store.getters.getMemberAPI,
      targetOrgMid: 0,
      transferType: 1,
      reason: '',
      personal: {},
      personalForm: false,
      transferCategory: [
        { text: '因重新加入，申請推薦人移轉', value: 1 },
        { text: '因特殊原因申請推薦人移轉，但仍須取得推薦人同意', value: 2 },
        { text: '因其它事由，申請推薦人移轉，請提出具體事證，不符不另通知', value: 3 }
      ]
    }
  },
  mounted: function () {
    this.token = this.$store.getters.getToken

    this.$http.get(this.memberurl + '/member_personal_info', {
      params: {
        token: this.token
      }
    }).then(function (res) {
      let data = res.body.data
      this.personal = data
    }, function () {
      console.log('failed')
    })
  },
  methods: {
    ...mapActions([
      'GET_NEWS'
    ]),
    applyTransfer () {
      let reason = this.reason
      let targetOrgMid = parseInt(this.targetOrgMid)
      let transferType = this.transferType
      let message = ''
      let orgMid = parseInt(this.personal.org_mid)

      if (!reason) {
        message += '請確認填寫申請原因後再送出\n'
      } else if (!targetOrgMid) {
        message += '請填寫預計移轉給誰\n'
      } else if (!transferType) {
        message += '請填寫申請的類型\n'
      } else if (orgMid === targetOrgMid) {
        message += '不可以移轉給自己\n'
      }

      if (message) {
        window.alert(message)
      } else {
        this.$http.post(this.memberurl + '/apply_transfer', {
          token: this.token,
          reason: reason,
          transfer_to_org_mid: targetOrgMid,
          category: transferType
        }).then(function (res) {
          let data = res.body
          if (data.status === 200) {
            window.alert(data.message)
            this.personalForm = false
          } else {
            window.alert(data.message)
          }
        }, function () {
          console.log('failed')
        })
      }
    },
    cancel () {
      this.personalForm = false
    }
  },
  computed: {
    ...mapGetters([
      'getUserID'
    ])
  }
}
</script>



// WEBPACK FOOTER //
// Transfer.vue?0873eeea